// extracted by mini-css-extract-plugin
export default {"results":"filters-with-cards_results__gRx1e","cardsView":"filters-with-cards_cardsView__m4rRt"};